<template>
    <div class="group" id="Experience">
        <div class="group-title">
            <h1>Experiencia</h1>
        </div>
        <div class="group-description">
            <div class="group-left">      
                <div class="group-down">
                    <div class="group-down-boxes" id="Mcdonalds" @mouseenter="job = 'McDonalds'" @mouseleave="job = 'WebDeveloper'">
                        <h2>Camarera / Personal de Equipo</h2>
                        <p>Mcdonals | Septiembre 2024 - Enero 2025</p>
                        <p>Atención al cliente, preparación de alimentos, limpieza, entre otras funciones. </p>
                    </div>

                    <div class="group-down-boxes" id="WebDeveloper" @mouseenter="job = 'WebDeveloper'" @mouseleave="job = 'WebDeveloper'">
                        <h2>Junior Web Developer</h2>
                        <p>Knowmad mood | Marzo 2024 - Junio 2024</p>
                        <p>Desarrollo de aplicaciones web con tecnologías como HTML, CSS, JavaScript, Vue.js, Node.js, Express.js, MongoDB, entre otras.</p>
                    </div>
            
                    <div class="group-down-boxes" id="Telemarketing" @mouseenter="job = 'Telemarketing'" @mouseleave="job = 'WebDeveloper'">
                        <h2>Operadora Telemarketing</h2>
                        <p>Konecta | Octubre 2021 - Marzo 2022</p>
                        <p>Atención al cliente, ventas, soporte técnico, entre otras funciones.</p>
                    </div>
            
                    <div class="group-down-boxes" id="Modeladora3D" @mouseenter="job = 'Modeladora3D'" @mouseleave="job = 'WebDeveloper'">
                        <h2>Modeladora 3D</h2>
                        <p>Nimoria Studio | Octubre 2020 - Marzo 2021</p>
                        <p>Modelado de personajes y escenarios en 3D para videojuegos.</p>
                    </div>
                    
                </div>
            </div>
            <div class="group-right">
                <div class="group-video">   
                    <template v-if="job === 'WebDeveloper'">
                        <video id="jobVideo" muted autoplay loop>
                            <source src="../../assets/webdeveloper.webm" type="video/mp4">
                        </video>
                    </template>
                    <template v-else-if="job === 'McDonalds'">
                        <video id="jobVideo" muted autoplay loop>
                            <source src="../../assets/mcdonalds.webm" type="video/mp4">
                        </video>
                    </template>
                    <template v-else-if="job === 'Telemarketing'">
                        <video id="jobVideo" muted autoplay loop>
                            <source src="../../assets/teleoperator.webm" type="video/mp4">
                        </video>
                    </template>
                    <template v-else-if="job === 'Modeladora3D'">
                        <video id="jobVideo" muted autoplay loop>
                            <source src="../../assets/3dmodeler.webm" type="video/mp4">
                        </video>
                    </template>

                </div>
            </div>
        </div>
    </div>



</template>

<script>
export default {
  data() {
    return {
      job: 'WebDeveloper',
    };
  },
};
</script>

<style scoped>
   .group-description{
        font-family: Roboto;
        display: grid;
        grid-template-columns: 1fr 1fr;
        width: 100%;
    }
    .group-right{
        display: flex;
        flex-direction:column;
        justify-content: center;
        align-items: center;
        background-color: #faf3e1;
    }

    .group-left{
        display: flex;
        flex-direction:column;
        justify-content: center;
        align-items: center;
        background-color: #faf3e1;
    }
    .group-title{

        display: flex;
        justify-content: center;
        h1{
            font-size: 3em;
            margin: 1em;
        }
    }

    .group-down{
        font-size: 1em;
        margin: 1em;
        width: 95%;

        animation: appear-video linear;
        animation-timeline: view();
        animation-range: entry 0% cover 40%;
    }

    .group-down-boxes{
        margin-left: 4em;
        background-color: #fdf9f8;
        border-radius: 1em;
        border: 2px solid #000000;
        box-shadow:2px 2px 1px #000000;
        padding: 0.3em;
        padding-left: 1em;
        margin-bottom: 1em;        
    }

    .group-down-boxes:hover{
        background-color: #78c2a7;
    }


    .group-video{
        width: 700px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 650px;
        border-radius: 1em;

        animation: appear-video linear;
        animation-timeline: view();
        animation-range: entry 0% cover 40%;
    }

    .group-video video{
        transform: scale(0.7);
    }

    @keyframes appear-left{
        from{
            opacity: 0;

            transform: translateX(-100%);
        }
        to{
            opacity: 1;
            transform: translateX(0%);
        }
    }

    @keyframes appear-video{
        from{
            opacity: 0;
            scale: 0.1;
        }to{
            opacity: 1;
            scale: 1;
        }
    }

</style>